// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description[data-v-870915f2]{min-height:256px}[data-v-870915f2] .foerdergelder-hinweis{margin-top:2em}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
